import Decimal from 'decimal.js'
/* 加 */
export function add(val, val2, { type = 'toString', retain, symbol } = {}) {
  return decimal(val, { ratio: val2, mode: 'add', type, retain, symbol })
}
/* 减 */
export function sub(val, val2, { type = 'toString', retain, symbol } = {}) {
  return decimal(val, { ratio: val2, mode: 'sub', type, retain, symbol })
}
/* 乘 */
export function mul(val, { ratio = 100, type = 'toString', retain, symbol } = {}) {
  return decimal(val, { ratio, mode: 'mul', type, retain, symbol })
}
/* 除 */
export function div(val, { ratio = 100, type = 'toString', retain, symbol } = {}) {
  return decimal(val, { ratio, mode: 'div', type, retain, symbol })
}
/*
 * 综合方法
 * val：传过来的值
 * mode：为加减乘除等方法
 * ratio：需要计算的数据
 * type：Decimal需要转换为哪种数据类型
 * retain：需要保留几位小数
 * symbol：后缀的符号  例如 % 等
 */
export function decimal(val, { mode = 'mul', ratio = 100, type = 'toString', retain, symbol } = {}) {
  // 匹配正数负数小数  其余为false
  let isTrue = /[-+]?\d+(?:\.\d+)?/g.test(val)
  if (!isTrue) {
    return ''
  }
  let result = !retain
    ? !symbol
      ? new Decimal(val)[mode](new Decimal(ratio))[type]()
      : `${new Decimal(val)[mode](new Decimal(ratio))[type]()}${symbol}`
    : `${new Decimal(val)
        [mode](new Decimal(ratio))
        .toNumber()
        .toFixed(retain)}${symbol || ''}`
  return result
}
